import React, { FC } from 'react';
import classNames from 'classnames';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

interface IProps {
  text?: string;
  variant?: 'primary-outlined' | 'primary-text' | 'icon' | 'transparent';
  icon?: string;
  iconSize?: '24' | '20';
  radius?: 'circle' | '0' | '20';
  shape?: 'square';
  size?: 'small';
  className?: string;
  width?: 'auto';
  padding?: '0-26' | '0-64';
  isDisabled?: boolean;
  noHover?: boolean;
  id?: string;
  [restProps: string]: any;
}

const Button: FC<IProps> = ({
  text,
  width,
  variant,
  icon,
  iconSize,
  radius,
  className,
  padding,
  isDisabled,
  shape,
  size,
  noHover,
  id = '',
  ...restProps
}) => {
  return (
    <button
      disabled={isDisabled}
      id={id}
      className={classNames(
        css.button,
        {
          [css[`button_radius_${radius}`]]: radius,
          [css[`button_variant_${variant}`]]: variant,
          [css[`button_width_${width}`]]: width,
          [css[`button_padding_${padding}`]]: padding,
          [css[`button_shape_${shape}`]]: shape,
          [css[`button_size_${size}`]]: size,
          [css.isDisabled]: isDisabled,
          [css.noHover]: noHover,
        },
        className,
      )}
      {...restProps}
    >
      <span className={css.button__content}>
        {icon && (
          <span
            className={classNames(css.button__icon, {
              [css[`button__icon_size_${iconSize}`]]: iconSize,
            })}
          >
            <Icon id={icon} />
          </span>
        )}
        {text && <span className={css.button__text}>{text}</span>}
      </span>
      {!noHover && <span className={css.button__ripple} />}
    </button>
  );
};

export default Button;
